
import React, { useState } from 'react';
import { X } from 'lucide-react';
import './EditPersonModal.css';

const EditPersonModal = ({ person, persons, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    // name: person.name,
    // personId: person.personId,
    // assignedTo: person.assignedTo,
    // type: person.type
    name: "Claudiu",
    personId: "asdasd",
    assignedTo: "Ariana",
    type: "Consultant"
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.personId || !formData.assignedTo) {
      alert('Please fill in all required fields');
      return;
    }

    onSave({
      ...person,
      ...formData
    });
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Edit Person</h3>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="edit-form">
          <div className="form-group">
            <label>Person Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Person ID</label>
            <input
              type="text"
              value={formData.personId}
              onChange={(e) => handleInputChange('personId', e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Assigned To</label>
            <input
              type="text"
              value={formData.assignedTo}
              onChange={(e) => handleInputChange('assignedTo', e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Type</label>
            <div className="type-selection">
              <button
                type="button"
                className={`type-btn ${formData.type === 'Member' ? 'active member' : ''}`}
                onClick={() => handleInputChange('type', 'Member')}
              >
                Member
              </button>
              <button
                type="button"
                className={`type-btn ${formData.type === 'Consultant' ? 'active consultant' : ''}`}
                onClick={() => handleInputChange('type', 'Consultant')}
              >
                Consultant
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn">Save Changes</button>
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPersonModal;
